import { skipToken } from '@reduxjs/toolkit/dist/query';
import AppHead from 'components/AppHead';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import RTKError from 'components/RTKError';
import { setCookie } from 'lib/auth/sessionSlice';
import MerchantBadges from 'lib/merchant/components/MerchantBadges';
import MerchantDescription from 'lib/merchant/components/MerchantDescription';
import MerchantHead from 'lib/merchant/components/MerchantHead';
import MerchantHero from 'lib/merchant/components/MerchantHero';
import MerchantMoreInfo from 'lib/merchant/components/MerchantMoreInfo';
import MerchantProducts from 'lib/merchant/components/MerchantProducts';
import MerchantTitle from 'lib/merchant/components/MerchantTitle';
import {
  getMerchant,
  getRunningOperationPromises,
  useGetMerchantQuery,
} from 'lib/shop/api';
import { wrapper } from 'lib/store';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';

// TODO: Could change this to static render - see posts
// would need a server api to get all the merchant slugs etc..
export const getServerSideProps = wrapper.getServerSideProps(
  store => async context => {
    // Store the cookie in session so our queries can access it in SSR
    store.dispatch(setCookie(context.req.headers.cookie ?? null));

    // Get the post
    store.dispatch(
      getMerchant.initiate({ idOrSlug: context.params?.merchantId as string }),
    );

    // Wait for all the requests to finish
    await Promise.all(getRunningOperationPromises());

    return {
      props: {},
    };
  },
);

export default function MerchantDetailPage() {
  const router = useRouter();
  const { merchantId } = router.query;

  const {
    data: merchant,
    isLoading: isMerchantLoading,
    error,
  } = useGetMerchantQuery(
    router.isReady && merchantId
      ? { idOrSlug: merchantId as string }
      : skipToken,
  );

  return (
    <>
      <Head>
        <MerchantHead merchant={merchant} />
        <AppHead />
      </Head>
      <Header />
      <div className="container mx-auto max-w-3xl py-6 md:py-12">
        <RTKError error={error} />
        {!isMerchantLoading && merchant && (
          <div className="mx-4">
            {/* Title section */}
            <MerchantTitle merchant={merchant} />

            {/* Hero */}
            <MerchantHero merchant={merchant} />

            {/* Badges */}
            <MerchantBadges />

            {/* Description */}
            <MerchantDescription merchant={merchant} />

            {/* Commented out until greener defines what to do with them. */}
            {/* Supergreen */}
            {/* <MerchantSupergreen merchant={merchant} /> */}

            {/* Products */}
            <MerchantProducts merchant={merchant} />

            {/* More info */}
            <MerchantMoreInfo merchant={merchant} />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
